import { Trans } from '@lingui/react'
import { bool, string } from 'prop-types'

import IconArrowRight from 'views/components/atoms/Icon/IconArrowRight'

const FollowUpProductLink = ({ followUpProductCode }) =>
  followUpProductCode ? (
    <a
      href={followUpProductCode}
      className="u-display--block m-ProductVariant__FollowUpProductLink"
    >
      <Trans id="productVariants.link.toSuccessor" />
      <IconArrowRight />
    </a>
  ) : null

FollowUpProductLink.propTypes = {
  followUpProductCode: string.isRequired,
}

const FollowUpProductLabel = ({ isOutOfStock }) => {
  if (isOutOfStock) {
    return <Trans id="general.label.product.currentlyNotAvailable" />
  }

  return <Trans id="productVariants.label.noLongerVariant" />
}

FollowUpProductLabel.propTypes = {
  isOutOfStock: bool.isRequired,
}

const NonAvailableVariantDetails = ({
  followUpProductCode,
  isOutOfTrade,
  isOutOfStock,
}) => (
  <div className="l-flex__full-width u-text-align--right u-padding--left u-font-weight--bold m-ProductVariant__no-trade-container">
    <FollowUpProductLabel isOutOfStock={isOutOfStock} />

    {isOutOfTrade && (
      <FollowUpProductLink followUpProductCode={followUpProductCode} />
    )}
  </div>
)

NonAvailableVariantDetails.propTypes = {
  followUpProductCode: string.isRequired,
  isOutOfTrade: bool.isRequired,
  isOutOfStock: bool.isRequired,
}

export default NonAvailableVariantDetails
